import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const FooterMessage = ({ newStatus, onChange, value }) => {
  const intl = useIntl();
  const [isFocused, setIsFocused] = useState(false);
  
  const placeholder = newStatus === 'REJECT'
    ? intl.formatMessage({ id: 'menssageForReject' })
    : intl.formatMessage({ id: 'menssageForAccept' });

  return (
    <div className="w-full" style={{ paddingTop: '16px' }}>
      <textarea
        rows={5}
        value={value}
        onChange={event => onChange(event.target.value)}
        placeholder={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="w-full p-[8px_12px] text-[calc(6px+0.4vw)] bg-white rounded-[4px] outline-none transition-all resize-none placeholder:text-[#adb5bd] font-normal"
        style={{
          height: 'auto',
          lineHeight: '1.5',
          color: '#393939',
          fontFamily: "'Open Sans', sans-serif",
          border: isFocused ? '1px solid #80bdff' : '1px solid #ccc',
          boxShadow: isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
        }}
      />
    </div>
  );
};

FooterMessage.propTypes = {
  newStatus: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FooterMessage;
